<div class="card border-0 bg-transparent d-none d-xl-block" v-if="token_exists">
  <h6 class="card-header bg-transparent">Upcoming events</h6>
  <div v-if="user_events.length === 0" class="text-center">
    <p class="text-muted text-xs fst-italic">You don't have any events</p>

  </div>
    <div class="d-flex mt-3 " v-for="user_event in filteredEvents">
      <div class="date-box bg-dark text-xxs">
        <h6 class="mt-1 text-change">{{ formatDay(user_event.start_date) }}<br>
          <span class="text-xxs fw-bold">{{ formatMonth(user_event.start_date) }}</span>
        </h6>
      </div>
      <div class="flex-grow-1 mx-1">
        <h6 class="text-xs">{{user_event.event_name}}<br>
          <span class="text-xxs text-muted"><small class="text-muted">{{formatDate(user_event.start_date)}}, {{ user_event.start_time ?
                    form_time(user_event.start_time) : "" }} -
                    {{ user_event.end_time ? form_time(user_event.end_time) : "" }}</small></span></h6>

        <div class="d-flex gap-2 mx-auto">
          <button v-if="!user_event.is_rsvped" class="text-xxs bg-primary rounded-3 border-0 shadow-sm px-4 text-white"
            @click="selectEvent(user_event)" data-bs-toggle="modal" data-bs-target="#eventModal">RSVP</button>
            <button v-else class="text-xxs bg-danger rounded-3 border-0 shadow-sm px-4 text-white"
            @click="cancelRSVP(user_event.id)">Cancel RSVP</button>
          <a class="text-xxs rounded-3 border-0 bg-dark shadow-sm px-4 text-white text-decoration-none" href="/view_events">More Info</a>
        </div>
      </div>
    </div>
  <div v-if="user_events.length > visibleCount" class=" mt-2">
    <button class="btn btn-sm btn-transparent text-secondary" @click="toggleShowMore">
    
      <i v-if="showAll" class="bx bxs-up-arrow-circle ms-2"></i> 
      <i v-if="!showAll" class="bx bxs-down-arrow-circle ms-2"></i>

      {{ showAll ? 'See Less' : 'See More' }}
    </button>
  </div>
</div>


<div class="modal fade" id="eventModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-5 border-0 shadow-sm">
      <div class="modal-header border-0">
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal"></button>
      </div>
      <div class="modal-body modal-body-scroll d-flex flex-column align-items-center text-center">

        <img src="@/assets/images/thank-you.png" class="w-150" alt="">
        <h6 class="text-center">Thank you for registering</h6>
        <p class="text-center">Please confirm your RSVP below</p>

        <!-- JOIN LINK FOR ONLINE EVENTS -->
        <div v-if="(selectedEvent.event_type?.name === 'online' || selectedEvent.event_type?.name === 'hybrid') && selectedEvent.event_link">
          <a v-if="isEventStarted(selectedEvent).canJoin"
             :class="['btn', 'btn-sm', 'fw-500', 'me-2', 'btn-primary']"
             :href="selectedEvent.event_link">
            Join Event
          </a>
          <p v-else class="text-muted text-sm mt-1">
            {{ isEventStarted(selectedEvent).message }}
          </p>
        </div>

        <!-- RSVP / CANCEL LOGIC -->
        <div v-if="selectedEvent.event_type?.name !== 'online' && selectedEvent.event_type?.name !== 'hybrid'">
          <span v-if="!isWithinRSVPPeriod(selectedEvent).isValid" class="d-inline-block">
            <button :class="[
                      'btn',
                      'btn-sm',
                      'fw-500',
                      selectedEvent.is_rsvped ? 'btn-warning' : 'btn-primary'
                    ]" disabled style="pointer-events: none;">
              {{ selectedEvent.is_rsvped ? 'RSVP’d' : 'Confirm RSVP' }}
            </button>
            <p class="text-danger text-xs">{{ isWithinRSVPPeriod(selectedEvent).message }}</p>
          </span>

          <button v-else class="gap-3" :class="[
                    'btn',
                    'btn-sm',
                    'fw-500',
                    'me-2',
                    selectedEvent.is_rsvped ? 'btn-warning' : 'btn-primary'
                  ]" @click="fetchEvents_extras(selectedEvent.id)">
            {{ selectedEvent.is_rsvped ? 'RSVP’d' : 'Confirm RSVP' }}
          </button>
        </div>

      </div>
    </div>
  </div>
</div>



  <div class="modal fade" id="rsvp_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <p class="modal-title text-xs fw-500" id="exampleModalLabel">RSVP</p>
                <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <form @submit.prevent="addRsvp">
                <div class="modal-body modal-body-scroll">
                  <label v-if="cbo_domain"for="businessName"> Provide business name</label>
                  <input v-if="cbo_domain"type="text" v-model="businessName" placeholder="Business Name" class="form-control rounded-5 text-xs">

                  <div v-if="cbo_domain" class="form-group mt-2 mb-3">
                    <label for="firstTimeSelect">Is this your first time attending?</label>
                    <select v-model="isFirstTime" class="form-control rounded-5 text-xs" id="firstTimeSelect">
                      <option disabled value="">Please select an option</option>
                      <option :value="true">Yes</option>
                      <option :value="false">No</option>
                    </select>
                  </div>
                  <div v-if="cbo_domain" class="form-group mt-2 mb-3">
                    <label for="chapterSelect">Home Chapter</label>
                    <select v-model="chapter" class="form-control rounded-5 text-xs" id="chapterSelect">
                      <option disabled value="">Please select a chapter</option>
                      <option v-for="chapter in chapters" :key="chapter" :value="chapter">{{ chapter }}</option>
                    </select>
                  </div>
                    <!-- Menu Selection -->
                    <div v-for="extra in eventExtras" :key="extra.id" class="form-check mb-2 mt-3">
                        <label class="form-check-label text-xs" :for="extra.extra.id">{{ extra.extra.name }}</label>
                        <div v-for="item in extra.items" :key="item.item_name" class="d-flex align-items-center gap-2 mb-2">
                          <input class="form-check-input mt-1" type="checkbox"
                                 :name="item.item_name" :id="item.item_name"
                                 v-model="selectedItemId" :value="item.id">
                          <div class="d-flex justify-content-between w-100">
                              <div class="d-inline-flex flex-wrap text-muted">
                                  <strong>{{ item.item_name }}</strong>
                                  <span class="fst-italic ms-1">{{ item.description }}</span>
                              </div>
                              <div v-if="!workbook_domain" class="text-end fst-italic text-primary ms-3">
                                  (R{{ item.price }})
                              </div>
                          </div>
                      </div>


                    </div>

                    <!-- Validation Message -->
                    <p v-if="formError" class="text-danger text-xs">Please select at least one item to RSVP.</p>

                    <!-- Dietary Restrictions -->
                    <div class="mb-4 d-none">
                        <label class="form-label text-xs fw-500">Additional Restrictions</label>
                        <textarea class="form-control rounded-5 text-xs" rows="2"
                                  placeholder="Please specify any allergies or restrictions" v-model="dietaryRestrictions"></textarea>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="submit" class="btn btn-primary text-xs rounded-5" :disabled="!selectedItemId.length">Submit</button>
                </div>
            </form>
        </div>
    </div>
</div>

